import consumer from "./consumer"

consumer.subscriptions.create(
  {
    channel: "UserChannel"
  },
  {
    initialized() {
      // console.log('init')
    },
    connected() {
      // console.log('connected')
    },
    disconnected() {
      // console.log('disconnected')
    },
    received(data) {
      // console.log('data received')
      // eslint-disable-next-line no-undef
      Turbo.renderStreamMessage(data);
    }
  }
);
